export const ADD_COMMENT = 'COMMENT/CREATE';
export const LOAD_COMMENTS = 'COMMENT/LOAD';
export const DELETE_COMMENT = 'COMMENT/DELETE';
export const LOADING_STATUS = 'COMMENT/LOADING_STATUS';
